import { render, staticRenderFns } from "./businessCooperation.vue?vue&type=template&id=bb5bc0a4&scoped=true"
import script from "./businessCooperation.vue?vue&type=script&lang=js"
export * from "./businessCooperation.vue?vue&type=script&lang=js"
import style0 from "./businessCooperation.vue?vue&type=style&index=0&id=bb5bc0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5bc0a4",
  null
  
)

export default component.exports